// extracted by mini-css-extract-plugin
module.exports = {"card":"card--2pMUHp7ON2","icons":"icons--3et_xuZ4af"};